import { useMutation, useQuery } from '@tanstack/react-query';
import { requestReset, submitNewPassword, verifyResetToken } from '../api/passwordApi';

export function useRequestResetMutation() {
  return useMutation({ mutationFn: requestReset });
}

export function useSubmitNewPasswordMutation() {
  return useMutation({ mutationFn: submitNewPassword });
}

/** Проверяет ссылку сброса один раз при загрузке страницы.
 *  `enabled` только при наличии токена; без ретраев — мёртвая ссылка не лечится. */
export function useVerifyResetTokenQuery(token: string | null) {
  return useQuery({
    queryKey: ['reset-token', token],
    queryFn: () => verifyResetToken(token as string),
    enabled: Boolean(token),
    retry: false,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
}
